// [AI GENERATED CODE] Updated to React Router v6 - replaced withRouter with useLocation hook
import React, { useEffect, Fragment } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToTop({ children }) {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return <Fragment>{children}</Fragment>;
}

export default ScrollToTop;